import { render, staticRenderFns } from "./AsPartInfoTableContainer.vue?vue&type=template&id=528eb410&"
import script from "./AsPartInfoTableContainer.vue?vue&type=script&lang=js&"
export * from "./AsPartInfoTableContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports